import React from 'react';
import { Check } from 'lucide-react';
export function BonusCard() {
  return <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 my-10" data-id="element-81">
      <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-82">
        Speciale Bonus Voor Deelnemers
      </h3>
      <div className="space-y-4" data-id="element-83">
        {['Exclusieve Q&A sessie na afloop', 'Downloadbare hand-outs met oefeningen', 'Toegang tot de besloten community'].map((benefit, index) => <div key={index} className="flex items-start" data-id="element-84">
            <div className="mr-4 mt-1 bg-green-50 rounded-full p-1" data-id="element-85">
              <Check className="text-green-600 w-4 h-4" strokeWidth={3} data-id="element-86" />
            </div>
            <span className="text-gray-700 font-medium" data-id="element-87">{benefit}</span>
          </div>)}
      </div>
    </div>;
}